      
import { Package } from 'react-feather'
import { newFormatThousandSeparator } from 'utils/formatNumber'

// Sums landplottingitem amounts per item + unit across the given plots.
export const aggregateItems = (plots) => {
  const byKey = {}
  ;(plots || []).forEach((plot) =>
    (plot?.landplottingitem || []).forEach((it) => {
      if (!it?.nameItem) return
      const key = `${it.nameItem}|${it.unit || ''}`
      if (!byKey[key]) {
        byKey[key] = {
          key,
          name: it.nameItem,
          unit: it.unit,
          photo: it.linkFoto,
          amount: 0,
          plots: new Set(),
        }
      }
      byKey[key].amount += parseFloat(it.amount) || 0
      byKey[key].plots.add(plot?.code)
    }),
  )
  return Object.values(byKey).sort((a, b) => a.name.localeCompare(b.name, 'id'))
}

export default function ItemList({ items, empty, showPlotCount = false }) {
  if (!items.length) return <div className="gm-muted">{empty}</div>
  return (
    <ul className="gm-items">
      {items.map((it) => (
        <li key={it.key} className="gm-item">
          <span className="gm-item-thumb">
            <Package size={16} />
            {it.photo ? (
              <img
                src={it.photo}
                alt=""
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = 'none'
                }}
              />
            ) : null}
          </span>
          <span className="gm-item-body">
            <span className="gm-item-name">{it.name}</span>
            {showPlotCount && it.plots.size > 1 ? (
              <span className="gm-item-sub">di {it.plots.size} lahan</span>
            ) : null}
          </span>
          <span className="gm-item-amount">
            {newFormatThousandSeparator(it.amount)} {it.unit || ''}
          </span>
        </li>
      ))}
    </ul>
  )
}

    